import axios, { AxiosInstance } from "axios";
import { storeToRefs } from "pinia";

export default class ApiVerified {
  public axiosInstance: AxiosInstance;

  constructor(apiBaseUrl: string, overrideAccessToken?: string) {
    this.axiosInstance = axios.create({
      baseURL: `${apiBaseUrl}/`,
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
          if (Array.isArray(value)) {
            value.forEach((v) => searchParams.append(key, String(v)));
          } else if (value !== null && value !== undefined) {
            searchParams.append(key, String(value));
          }
        }
        return searchParams.toString();
      },
    });

    this.axiosInstance.interceptors.request.use(
      async (config) => {
        const { useSessionStore } = await import("@/stores/core/sessionStore");
        const sessionStore = useSessionStore();
        const { UserInfo } = storeToRefs(sessionStore);
        const accessToken = overrideAccessToken || UserInfo.value.AccessToken || "";
        config.headers["Authorization"] = `Bearer ${accessToken}`;
        return config;
      },
      (error) => Promise.reject(error),
    );
    this.axiosInstance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 403 && !originalRequest._retry) {
          const { useSessionStore } = await import("@/stores/core/sessionStore");
          const sessionStore = useSessionStore();
          originalRequest._retry = true;
          const newAccessToken = await sessionStore.refreshAccessToken();
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axios(originalRequest);
        }
        return Promise.reject(error);
      },
    );
  }
}
